module.exports = __webpack_public_path__ + "img/boolzapp.899c09cf.png";